import styled from 'styled-components';
import { H5 } from 'components/Core/Typography';

const Container = styled.div`
  position: relative;
  min-height: 0;

  .webinar-guest-speaker--main-container {
    display: flex;
    margin: 15px -20px 0 0;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;

    p {
      margin-bottom: 0;
    }

    .webinar-guest-speaker--item {
      width: calc(50% - 20px);
      margin: 0 20px 20px 0;
    }

    .slick-slider {
      max-width: 100%;
    }
  }

  @media (max-width: 576px) {
    .webinar-guest-speaker--main-container {
      margin: 17px 0 0;
      flex-direction: column;

      .webinar-guest-speaker--item {
        width: 100%;
      }
    }
  }

  &.sidebar-mode {
    .webinar-guest-speaker--main-container {
      flex-direction: column;
      margin-right: 0;

      .webinar-guest-speaker--item {
        width: 100%;
        margin: 0;
      }
    }

    .slick-track {
      height: 100% !important;
    }
  }
`;

const Title = styled(H5)`
  color: var(--black);
  font-weight: bold;
  font-size: 20px;
  line-height: 120%;
`;

const GuestSpeakerItem = styled.div`
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
  border-radius: 2px;
  display: flex;
  width: 100%;
  padding: 15px;
  margin: 0;
  min-width: 0;
  position: relative;
  transition: all 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  cursor: pointer;

  &:hover {
    box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  }

  .webinar-guest-speaker--photo-container {
    display: flex;
    align-items: center;

    .webinar-guest-speaker--photo-image {
      width: 75px;
      height: 75px;
      max-width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 50%;

      @media (max-width: 992px) {
        height: 60px;
        width: 60px;
      }
    }
  }

  .webinar-guest-speaker--content-container {
    padding: 0 0 0 14px;
    position: relative;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h6,
    p {
      white-space: nowrap;
    }

    &:after {
      height: 100%;
      width: 20px;
      background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      position: absolute;
      content: ' ';
      right: 0;
      top: 0;
    }

    .webinar-guest-speaker--company-text {
      display: none;
    }

    .webinar-guest-speaker--link-text {
      color: var(--secondary-color);
      margin: 0;
      font-weight: bold;
      line-height: 110%;
      margin-top: 3px;
    }
  }

  .webinar-guest-speaker--link {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  &.hovered {
    .webinar-guest-speaker--content-container {
      .webinar-guest-speaker--link-text {
        color: var(--secondary-hover-color);
      }
    }
  }

  &.sidebar-mode {
    background: transparent;
    box-shadow: none;
    padding: 20px 0;
    cursor: default;

    &:hover {
      box-shadow: none;
    }

    .webinar-guest-speaker--photo-container {
      .webinar-guest-speaker--photo-image {
        width: 60px;
        height: 60px;
      }
    }

    .webinar-guest-speaker--content-container {
      .webinar-guest-speaker--name {
        font-size: 16px;
      }

      .webinar-guest-speaker--job-text {
        font-size: 14px;
      }

      .webinar-guest-speaker--company-text {
        display: block;
        font-size: 14px;
      }

      .webinar-guest-speaker--link-text {
        display: none;
      }

      &:after {
        content: none;
      }
    }

    @media (max-width: 576px) {
      margin: 0;
    }
  }
`;

const SliderArrow = styled.div`
  width: 30px;
  height: 30px;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
  padding: 7px;
  position: absolute;
  top: -45px;
  right: 0;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  }

  svg {
    max-width: 100%;
    max-height: 100%;
    opacity: 0.5;
  }

  &.prev-arrow {
    right: 36px;

    svg {
      transform: scale(-1);
    }
  }

  &.disabled {
    svg {
      opacity: 0.1;
    }
  }
`;

export { Container, Title, GuestSpeakerItem, SliderArrow };
